module.exports = {
  setConfig: require("./lib/config/env").setConfig,
  generateSitemap: require("./lib/generateSitemap").generateSitemap,
};
